import React, { useMemo } from 'react';
import { Container } from '@/ui/layout';
import { FormInput } from '../../components';
import { CountrySelect } from '../../Fields';
import { useTranslation } from 'react-i18next';
import { Card } from 'antd';

export const AddressBox = ({ label, form, disabled, adminView, required, children }) => {
  const { t } = useTranslation();
  const { name, control, rules, ...otherForm } = form;

  const resultRules = useMemo(() => {
    if (rules) {
      const { required, ...propsRules } = rules;

      return { required, otherRules: propsRules };
    }

    return {};
  }, [rules]);

  return (
    <Container $paddingTop={10}>
      <Card
        size='small'
        title={label}
        styles={{
          title: {
            fontSize: '14px',
            fontWeight: 400
          }
        }}
      >
        {/*<Body1Light marginBottom={24}>{label || name}</Body1Light>*/}
        {!adminView && children}

        {fields.map((field, key) => {
          const RenderedField = componentByType[field];
          const fieldRequired =
            field !== 'Region' && field !== 'ApartmentNumber' && resultRules.required;

          return (
            <Container $marginBottom={16} key={key}>
              <RenderedField
                form={{
                  name: `${name}.${field}`,
                  control: control,
                  rules: {
                    required: fieldRequired,
                    ...resultRules.otherRules
                  },
                  ...otherForm
                }}
                label={t(labelByType[field])}
                required={field !== 'Region' && field !== 'ApartmentNumber' && required}
                disabled={disabled}
              />
            </Container>
          );
        })}
      </Card>
    </Container>
  );
};

const fields = [
  'Country',
  'ZipCode',
  'Region',
  'City',
  'StreetName',
  'HouseNumber',
  'ApartmentNumber'
];

const componentByType = {
  Country: CountrySelect,
  ZipCode: FormInput,
  Region: FormInput,
  City: FormInput,
  StreetName: FormInput,
  HouseNumber: FormInput,
  ApartmentNumber: FormInput
};
const labelByType = {
  Country: 'Country',
  ZipCode: 'Zip/Postal code',
  Region: 'Region',
  City: 'City',
  StreetName: 'Street Name',
  HouseNumber: 'House Number',
  ApartmentNumber: 'Apartment Number'
};
